import { gql } from '@apollo/client';

export const CREATE_BELEGUNGEN = gql`
  mutation dienstplan_createBelegung(
    $input: dienstplan_create_belegungen_input!
  ) {
    dienstplan_createBelegungen(createBelegungenInput: $input) {
      id
      dauer
      von
      anzahlMitarbeiter
    }
  }
`;

export const UPDATE_BELEGUNG = gql`
  mutation dienstplan_updateBelegung(
    $input: dienstplan_updateBelegungenInput!
  ) {
    dienstplan_updateBelegung(input: $input)
  }
`;

export const DELETE_BELEGUNG = gql`
  mutation dienstplan_deleteBelegung($belegungId: String!) {
    dienstplan_deleteBelegung(belegungId: $belegungId)
  }
`;
